import styled, { css } from "styled-components";
import InputMask from "react-input-mask";

export const PhoneInput = styled(InputMask)`
  ${({ theme: { breakpoints } }) => css`
    display: flex;
    align-items: center;
    height: 44px;
    width: 283px;
    font-size: 13px;
    padding: 0 16px;
    align-self: center;

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      width: 300px;
      margin-top: 0;
      font-size: 16px;
    }

    @media (max-width: ${breakpoints.mobileWidth}) {
      width: 250px;
      margin-top: 0;
      font-size: 16px;
    }
  `}
`;

export const InputWrapper = styled.div`
  ${({ theme: { colors } }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 8px;
    border-radius: 10.5px;
    border: 1px solid ${colors.lineGray};
    padding: 0 16px;
    align-items: center;
    margin-top: 32px;
    
    .ant-select {
      max-width: 100px !important;
      width: 100% !important;
    }
    
    .ant-select-selector {
      background-color: ${colors.lineGray} !important;
      border-radius: 4px !important;
      border-color: transparent !important;
      box-shadow: none !important;
    }
    
    .region-select-dropdown {
      width: 280px !important;
    }

    .region-select-dropdown .ant-select-item-option-active {
      background-color: ${colors.lineGray} !important;
    }
    
    .region-select-dropdown .ant-select-item-option-selected {
      background-color: ${colors.lineGray} !important; /* например, светло-зелёный */
    }
  `}
`;

export const FlagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: nowrap;
  gap: 8px;

  svg {
    max-width: 18px;
  }
`;

export const RegionCode = styled.span`
    font-size: 14px;
`;
